<div>
  <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis" [title]="chartOptions.title"></apx-chart>
</div>